import { render, staticRenderFns } from "./TemplateApptForm.vue?vue&type=template&id=53a23e30&scoped=true"
import script from "./TemplateApptForm.vue?vue&type=script&lang=js"
export * from "./TemplateApptForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateApptForm.vue?vue&type=style&index=0&id=53a23e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a23e30",
  null
  
)

export default component.exports